module.exports = __webpack_public_path__ + "static/media/icon-plus.48c3e6a0.svg";